import 'mdn-polyfills/NodeList.prototype.forEach';

export default class Quiz {
  constructor(element) {
    this.element = element;
    this.body = document.querySelector("body");
    
    this.changeButtonPressed = this.changeButtonPressed.bind(this);

  }

  mount() {
    this.element.addEventListener('click', this.changeButtonPressed);
  }

  changeButtonPressed() {
    if (this.element.getAttribute("aria-pressed") === "true") {
      this.element.setAttribute("aria-pressed" , "false")
      this.body.classList.remove("has-pins");
    } else {
      this.element.setAttribute("aria-pressed" , "true")
      this.body.classList.add("has-pins");
    }
  }

  unmount() {
  }
}
